// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useEffect, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useCurrentFormState } from '../../../../../../../controllers/issue-adjustments/hooks/use-current-form-state';
import { useLastProcessedChange } from '../../../../../../../controllers/issue-adjustments/hooks/use-last-change';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { isScreenTabsSupportEnabled } from '../../../../../../../controllers/view-configuration';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { filterFormDataBasedOnScopes } from '../utils/filter-based-on-scopes/form-data';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { filterScreenTabsBasedOnReadScopes } from '../utils/filter-based-on-scopes/screen-tabs-data';
export var useOnChangeSubscription = function useOnChangeSubscription(_ref) {
  var uiModifications = _ref.uiModifications,
    moduleScopes = _ref.moduleScopes;
  var viewType = useViewType();
  var notifyAppRef = useRef(null);
  var _useLastProcessedChan = useLastProcessedChange(),
    lastProcessedChange = _useLastProcessedChan.lastProcessedChange;
  var _useCurrentFormState = useCurrentFormState(),
    currentFormState = _useCurrentFormState.currentFormState,
    currentScreenTabsState = _useCurrentFormState.currentScreenTabsState;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;

  /**
   * Single ref for all data that must be up-to-date but not trigger notification.
   */
  var dataRef = useRef({
    currentFormState: currentFormState,
    currentScreenTabsState: currentScreenTabsState,
    uiModifications: uiModifications,
    moduleScopes: moduleScopes,
    viewType: viewType
  });
  dataRef.current = {
    currentFormState: currentFormState,
    currentScreenTabsState: currentScreenTabsState,
    uiModifications: uiModifications,
    moduleScopes: moduleScopes,
    viewType: viewType
  };
  useEffect(function () {
    var notifyApp = notifyAppRef.current;
    if (notifyApp === null || lastProcessedChange === null) {
      return;
    }
    var changeId = lastProcessedChange.changeId;
    notifyApp({
      changedFieldId: lastProcessedChange.fieldId,
      changeId: changeId,
      currentFormState: filterFormDataBasedOnScopes(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
      currentScreenTabsState: isScreenTabsSupportEnabled(dataRef.current.viewType) ? filterScreenTabsBasedOnReadScopes(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState) : undefined,
      uiModifications: dataRef.current.uiModifications
    });
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'success',
      actionSubject: 'jiraUiModifications.appNotification',
      attributes: {
        lifecycleEvent: 'change',
        viewType: dataRef.current.viewType
      }
    });
  }, [viewType, createAnalyticsEvent, lastProcessedChange]);
  return useCallback(function (callback) {
    notifyAppRef.current = callback;
  }, []);
};